import StyleIcon from "@mui/icons-material/Style";
import CreateTradeNetwork from "./Create";

//params
export const TRADE_NETWORK_IMPORT = "trade-network/import";
//permissions

export const resources = {
  isMenu: true,
  icon: <StyleIcon />,
  name: TRADE_NETWORK_IMPORT,
  title: "Ваучери и карти",
  list: <CreateTradeNetwork />,
  permission: "vouchers",
};

//api url
